
import Vue from "vue";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { STANDARD_OFFER } from "@/store/standardOffer";
import { ROUTE_NAMES } from "@/routes";
import { isInSomeRole } from "@/helpers/auth";
import { SUPPORT, PRICING_TEAM } from "@/constants/roles";
import store from "@/store";

export default Vue.extend({
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.standardOffer.dataTable.pagination;
      },
      set(value: string) {
        this.$store.commit(
          STANDARD_OFFER.NS(STANDARD_OFFER.MUTATIONS.SET_DATA_TABLE_PAGINATION),
          value
        );
      }
    },
    hasEditAccess() {
      return isInSomeRole([PRICING_TEAM, SUPPORT]);
    },
    detailRouteName: () => ROUTE_NAMES.STANDARD_OFFER_DETAIL,
    ...mapState({
      offersList: (state: IRootState) => state.standardOffer.offersList
    })
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: this.detailRouteName,
        params: { id: item.id }
      });
    },
    onPagination(value: any) {
      this.pagination = value;
    }
  },
  async mounted() {
    this.isLoading = true;

    await this.$store.dispatch(
      STANDARD_OFFER.NS(STANDARD_OFFER.ACTIONS.LOAD_STANDARD_OFFERS_LIST)
    );

    this.isLoading = false;
  }
});
